import AES256_CBC from './AES256_CBC';
import RSA_OAEP from './RSA_OAEP';
import MD5 from './MD5';
import Utils from './Utils';


class RSA_OAEP_AES256_CBC {

    static importPublicKeyPEM(public_key) {

        return new Promise( (resolve, reject) => {

            if ( typeof public_key === "string" ) {
                RSA_OAEP.importPublicKeyPEM(public_key).then(resolve).catch(reject);
            }
            else {
                resolve(public_key);
            }
        });
    }

    static importPrivateKeyPEM(private_key) {

        return new Promise( (resolve, reject) => {

            if ( typeof public_key === "string" ) {
                RSA_OAEP.importPrivateKeyPEM(private_key).then(resolve).catch(reject);
            }
            else {
                resolve(private_key);
            }
        });
    }

    static encrypt(data, public_key) {

        return new Promise( (resolve, reject) => {

            if ( data && public_key ) {

                let checksum;

                if ( typeof data === "string" ) {
                    checksum = MD5.encrypt(data);
                    data = new TextEncoder().encode(data);
                }

                RSA_OAEP_AES256_CBC.importPublicKeyPEM(public_key).then( (public_key)=> {

                    AES256_CBC.genkeys().then( (aes_keys) => {

                        AES256_CBC.encrypt(data, aes_keys.key, aes_keys.iv).then( (encrypted) => {

                            AES256_CBC.exportKey(aes_keys.key).then( (key) => {

                                let header = JSON.stringify({
                                    'aes':{
                                        'key': Utils.btoa(key),
                                        'iv': Utils.btoa(aes_keys.iv)
                                    },
                                    'meta':{
                                        'length': encrypted.length,
                                        'checksum': checksum,
                                        'time': Math.round(new Date().getTime()/1000)
                                    }
                                });

                                if ( header ) {

                                    RSA_OAEP.encrypt(header, public_key).then( (signature) => {

                                        let encrypted_data = new Uint8Array(256 + encrypted.length);

                                        encrypted_data.set(signature);
                                        encrypted_data.set(encrypted, signature.length);

                                        resolve(encrypted_data);

                                    }).catch(reject);
                                }

                            }).catch(reject);

                        }).catch(reject);

                    }).catch(reject);

                }).catch(reject);
            }
        });
    }

    static decrypt(encrypted, private_key, validate) {

        return new Promise( (resolve, reject) => {

            validate = ( validate && validate === true ) ? true : false;

            if ( encrypted && private_key ) {

                if ( typeof encrypted === "string" ) {
                    encrypted = new Uint8Array(encrypted.split("").map( (c) => { return c.charCodeAt(0); }));
                }

                RSA_OAEP_AES256_CBC.importPrivateKeyPEM(private_key).then( (private_key) => {

                    if ( encrypted.length > 256 ) {

                        let signature = new Uint8Array(encrypted.buffer, 0, 256),
                        encrypted_data = new Uint8Array(encrypted.buffer, 256);

                        if ( signature && encrypted_data ) {

                            RSA_OAEP.decrypt(signature, private_key).then( ( decrypted_header ) => {

                                let headerData = new TextDecoder().decode(decrypted_header);

                                if ( headerData ) {

                                    let header = JSON.parse(headerData);

                                    if ( header ) {

                                        if ( encrypted_data.length == header.meta.length ) {

                                            AES256_CBC.importKey(Utils.atobAsArray(header.aes.key)).then( (key) => {

                                                AES256_CBC.decrypt(encrypted_data, key, Utils.atobAsArray(header.aes.iv)).then( (decrypted) => {

                                                    if ( validate ) {

                                                        if ( MD5.encrypt(new TextDecoder().decode(decrypted)) == header.meta.checksum ) {
                                                            resolve(decrypted);
                                                        }
                                                        else { reject(); }

                                                    } else {
                                                        resolve(decrypted);
                                                    }
                                                });

                                            }).catch(reject)
                                        }
                                        else { reject(); }
                                    }
                                    else { reject(); }
                                }
                                else { reject(); }

                            }).catch( reject );
                        }
                        else { reject(); }
                    }
                    else { reject(); }
                });
            }
        });
    }
}

export default RSA_OAEP_AES256_CBC;
